import { Box, Stack, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { ImageOutlined } from "@mui/icons-material";
import { QCMarkerCardProps } from "../../Cards/QCMarkerCard/qc-marker-card";
import { GetTimelineStoryboard } from "../../../Redux/Reducers/redux-slice-timeline";
import { useSelector } from "react-redux";
import StoryboardCard from "../../Cards/StoryboardCard/storyboard-card";
import EmptyListSlot from "../../Misc/EmptyListSlot";
import { FixedSizeGrid } from "react-window";
import { IPreviewTabContentProps } from "./preview-tabs";
import { useTranslation } from "react-i18next";

export const StoryboardTab: React.FC<IPreviewTabContentProps> = (props: IPreviewTabContentProps) => {
  const { t } = useTranslation();
  const { asset } = props;
  const storyboardContainer = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [containerHeight, setContainerHeight] = useState(0);
  const storyboardMarkers = useSelector(GetTimelineStoryboard);

  const [storyboardMarkersGrid, setStoryboardMarkersGrid] = useState<QCMarkerCardProps[][]>([]);

  const theme = useTheme();

  const [columnWidth, setColumnWidth] = useState(0);
  const [rowHeight, setRowHeight] = useState(0);

  // Scale
  const [scale, setScale] = useState(6);
  //const scales = [3, 4, 6, 12];

  useEffect(() => {
    const gridMarkers: QCMarkerCardProps[][] = [];
    let row: QCMarkerCardProps[] = [];

    for (let i = 0; i < storyboardMarkers.length; i++) {
      row.push(storyboardMarkers[i]);
      if (row.length === 12 / scale) {
        gridMarkers.push(row);
        row = [];
      }
    }
    if (row.length > 0) gridMarkers.push(row);
    setStoryboardMarkersGrid(gridMarkers);
  }, [scale, storyboardMarkers]);

  useEffect(() => {
    setColumnWidth((scale / 12) * containerWidth);
    setRowHeight((scale / 12) * containerWidth * (9 / 16));
  }, [scale, containerWidth]);

  const StoryboardCards = ({ columnIndex, rowIndex, style }) => {
    if (storyboardMarkersGrid[rowIndex][columnIndex] === null) return <div style={style}></div>;
    return (
      <Box sx={{ p: 0.5 }} style={style}>
        <StoryboardCard
          objectId={asset.id}
          id={storyboardMarkersGrid[rowIndex][columnIndex].id}
          timecodes={{
            in: storyboardMarkersGrid[rowIndex][columnIndex].timecodes.in,
            out: storyboardMarkersGrid[rowIndex][columnIndex].timecodes.out,
            frameRate: 25,
          }}
          thumbnail={storyboardMarkersGrid[rowIndex][columnIndex].thumbnail}
        />
      </Box>
    );
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver((event) => {
      setContainerWidth(event[0].contentBoxSize[0].inlineSize);
      setContainerHeight(event[0].contentBoxSize[0].blockSize);
    });

    if (storyboardContainer.current) resizeObserver.observe(storyboardContainer.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [storyboardContainer.current]);

  useEffect(() => {});

  return (
    <Stack gap={1} position="relative" ref={storyboardContainer} sx={{ width: "100%", height: "100%", p: 2 }}>
      {/* <Box
        sx={(theme) => ({
          position: "sticky",
          top: 0,
          zIndex: 2,
          px: 2,
          py: 2,
          background: theme.palette.background.default,
        })}
      >
        <ScaleSlider scales={scales} scale={scale} setScale={setScale} />
      </Box> */}
      {storyboardMarkers.length > 0 ? (
        <FixedSizeGrid
          columnCount={12 / scale}
          columnWidth={columnWidth}
          rowHeight={rowHeight}
          rowCount={storyboardMarkers.length / (12 / scale)}
          width={containerWidth + 16}
          height={containerHeight}
          style={{
            scrollbarWidth: "thin",
          }}
        >
          {StoryboardCards}
        </FixedSizeGrid>
      ) : (
        <EmptyListSlot title={t("page:emptyListSlot.title.storyboardIsEmpty")} icon={<ImageOutlined />} />
      )}
    </Stack>
  );
};
